import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-user-large",
  templateUrl: "./med-icon-user-large.component.html",
})
export class MedIconUserLargeComponent extends SvgMixinLargeComponent { }
